module.exports = __webpack_public_path__ + "static/media/25276491_1545557728827196_180953758_n_edited.180185b6.jpg";